import React from 'react'

import { AppContext } from '@/components/base/appcontext'

import { Typography } from '@/components/ui/typography'

function Loading() {
    const appContext = React.useContext(AppContext)
    return (
        <Typography variant="title-sm" textAlign="center">
            {appContext.geti18n('Loading...')}
        </Typography>
    )
}

export default Loading
